module.exports = __webpack_public_path__ + "static/media/clipboard.7d9f037d.svg";